// extracted by mini-css-extract-plugin
module.exports = {"proteinReason":"FaqSection_proteinReason__Fee3b","proteinGift":"FaqSection_proteinGift__zjed6","proteinQaBtn":"FaqSection_proteinQaBtn__bOa6o","image":"FaqSection_image__0I1sO"};